export default __webpack_public_path__ + "static/media/whatsapp.5e9c8e3a.svg";